var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.error_messages
        ? _c("errors", { attrs: { errors: _vm.error_messages } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "c-support-overlay js-overlay is-active" }, [
        _c(
          "div",
          { staticClass: "c-cookie" },
          [
            _c("h3", { staticClass: "c-heading-medium u-color-white" }, [
              _vm._v(
                _vm._s(_vm.translate("frontend.js.cookie_consent.info_cookie"))
              )
            ]),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.translate("frontend.js.cookie_consent.cookie_consent", {
                    privacy_statement_url: "/privacybeleid"
                  })
                )
              }
            }),
            _vm._v(" "),
            _vm.is_cookie_set === false
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "c-cookie-buttons-wrapper u-margin-top-small"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "button outlined u-no-margin-top u-margin-right-tiny",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setCookie(false)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.translate(
                                "frontend.js.cookie_consent.reject_cookie"
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "button is-secondary u-no-margin-top",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setCookie(true)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.translate(
                                "frontend.js.cookie_consent.accept_cookie"
                              )
                            )
                          )
                        ]
                      )
                    ]
                  )
                ]
              : [
                  _c(
                    "form",
                    {
                      staticClass: "c-form js-form-animation",
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.updatePreferences.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "c-cookie-switch-wrapper u-margin-top-small"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "u-bold u-white u-margin-right-tiny"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.translate(
                                    "frontend.js.cookie_consent.accept_cookie"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "switch u-margin-left-tiny u-no-margin-bottom"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.is_accepted,
                                    expression: "form.is_accepted"
                                  }
                                ],
                                staticClass: "switch-input",
                                attrs: { id: "switch", type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.form.is_accepted)
                                    ? _vm._i(_vm.form.is_accepted, null) > -1
                                    : _vm.form.is_accepted
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.form.is_accepted,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form,
                                            "is_accepted",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form,
                                            "is_accepted",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.form, "is_accepted", $$c)
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "switch-paddle",
                                attrs: { for: "switch" }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "c-cookie-buttons-wrapper u-margin-top-small"
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "button is-secondary u-no-margin-top u-no-margin-bottom",
                              attrs: {
                                type: "submit",
                                disabled: _vm.disable_submit
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.translate(
                                    "frontend.js.cookie_consent.save_cookie"
                                  )
                                )
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ea4fd1cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea4fd1cc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/frontend/vue/components/cookie-consent/cookie-consent.vue
// module id = 44
// module chunks = 0 10